import FlarumUserCard from 'flarum/forum/components/UserCard';
import icon from 'flarum/common/helpers/icon';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import classList from 'flarum/common/utils/classList';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import User from 'flarum/common/models/User';
import dayjs from 'dayjs';
import { SelectFollowUserTypeModal } from './SelectFollowLevelTypeModal';
import { initChat } from '@speareducation/talkjs';
import m from 'mithril';

export default class UserCard extends FlarumUserCard {
  userData = null;

  oninit(vnode) {
    super.oninit(vnode);

    this.getUserData(this.attrs.user).then(() => m.redraw());
  }

  view() {
    const { user, className, isDiscussionPage, address } = this.attrs;

    const openChat = async (e) => {
      e.preventDefault();

      const chat = await initChat();
      const convo = await chat.oneOnOne(user.id());
      const popover = chat.getPopover();
      popover.select(convo);
      popover.show();
    };

    const openFollowLevelModal = (user) => {
      if (!(user instanceof User)) return;

      app.modal.show(SelectFollowUserTypeModal, { user });
    };

    const hideFollowBtn = !app.session.user || app.session.user === user || !user.canBeFollowed();

    return (
      <div style={`${isDiscussionPage ? 'pointer-events: none;' : ''}`} className={classList('UserCard', className)}>
        <div className="UserCard-profile">
          <div className="UserCard-identity">
            <div>
              <Link href={app.route.user(user)}>
                <div className="UserCard-avatar">{avatar(user, { loading: 'eager' })}</div>
              </Link>
            </div>

            <div class="UserCard-about">
              {/* Display Name */}
              <h5>{username(user)}</h5>
              <p>
                {/* Actual username */}
                {user.username()}
                <br />
                Joined {dayjs(user.joinTime()).format('MMM DD, YYYY')}
                <br />
                <i className="fas fa-map-marker-alt"></i>
                {address}
              </p>
            </div>
          </div>
        </div>

        <div className="UserCard-buttons">
          <Link className="Button Button--primary" href={app.route.user(user)}>
            <span className="Button-label">{icon('far fa-user')} View Profile</span>
          </Link>

          {!hideFollowBtn && (
            <Button
              className="Button Button--primary"
              onclick={(e) => {
                e.preventDefault();
                openFollowLevelModal.bind(this, user)();
              }}
            >
              {icon('far fa-star')}
              {user.followed()
                ? app.translator.trans(`ianm-follow-users.forum.badge.label.${user.followed()}`)
                : app.translator.trans('ianm-follow-users.forum.user_controls.follow_button')}
            </Button>
          )}

          <Button className="Button Button--primary" onclick={(e) => openChat(e)}>
            {icon('far fa-envelope')} Send Message
          </Button>
        </div>

        <div>
          <ul className="UserCard--infotable">
            <li>
              {icon('fa fa-comments')} Discussions
              <span>{user.discussionCount() ?? 0}</span>
            </li>

            <li>
              {icon('fa fa-reply')} Replies
              <span>{user.commentCount() ?? 0}</span>
            </li>

            <li>
              {icon('fa fa-thumbs-up')} Likes
              <span>{user.data.attributes.likesReceived ?? 0}</span>
            </li>

            <li>
              {icon('fa fa-star')} Following
              <span>{user.followingCount() ?? 0}</span>
            </li>

            <li>
              {icon('fa fa-users')} Followers
              <span>{user.followerCount() ?? 0}</span>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  async getUserData(user) {
    if (!(user instanceof User)) return;

    try {
      app.store.find('users', user.id()).then((res) => {
        this.userData = res.data.attributes;
      });
    } catch (e) {
      console.error(`Error fetching user data: ${e}`);
    }
  };
}
